import L from '../leaflet-plugins-loader';
import { LeafletService } from '../leaflet.service'
import { TranslateService } from '@ngx-translate/core'
import { WidgetSettingsObserveService } from '../../../../shared/services/helpers/widget-settings-observe.service'
import { ILeafletInstance } from '../leaflet.interface'

export class OpenSeaMap extends LeafletService {
  private static readonly ressourceUrl: string = 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png'
  private static readonly options = {
    maxZoom: 20,
    minZoom: 3,
    maxNativeZoom: 19,
    detectRetina: false,
    updateWhenIdle: true,     // load tiles when user stops moving map (better performance)
    updateWhenZooming: false,
    attribution: '© <a href="https://www.openseamap.org">OpenSeaMap</a> contributors'
  }

  constructor(translate: TranslateService, widgetSettingObserve: WidgetSettingsObserveService) {
    super(translate, widgetSettingObserve)
  }

  static addSeaMapLayer(id: number | string, instance?: ILeafletInstance): void {
    const openSeaLayer = L.tileLayer(OpenSeaMap.ressourceUrl, OpenSeaMap.options)

    if (instance) {
      Object.assign(instance.tileLayers, {
        'OpenSeaMap': {
          layer: openSeaLayer,
          zoom: 10,
          id: `map_${id}`
        }
      })
    }
  }

  static addMiniMapLayerToInstance(id: number | string, instance?: ILeafletInstance) {
    if (instance?.layerControls.has(`minimap_${id}`)) {
      const miniMapControl = instance?.layerControls.get(`minimap_${id}`)
      if (miniMapControl) {
        instance.map.removeControl(miniMapControl)
      }
      instance.layerControls.delete(`minimap_${id}`)
    }

    if (instance) {
      // L.Control cannot reuse the same tileLayer
      const miniMapOSM = L.tileLayer(instance.tileLayers['OSM'].url)
      const minimMapTileLayer =   L.tileLayer(OpenSeaMap.ressourceUrl, OpenSeaMap.options)
      const layerGroup = L.layerGroup([miniMapOSM, minimMapTileLayer])

      const miniMap = new L.Control.MiniMap(layerGroup, {
        width: 215,
        height: 215,
        position: 'topright',
        toggleDisplay: true,
        minimized: true,
        zoomLevelOffset: -5
      }) as any

      miniMap.on('restore', () => {
        miniMap._miniMap.invalidateSize();
      });

      instance.layerControls.set(`minimap_${id}`, miniMap);
      miniMap.addTo(instance?.map)
    }
  }
}
